<template>
    <section class="page-section" v-loading="pageLoading">
                
                <el-form size="small" :model="form" :rules="rules" label-width="90px" class="content-form no-padding-bottom pt20" ref="form">
                    <el-form-item label="员工姓名" prop="name">
                        <el-input class="w150" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="mobile">
                        <el-input class="w150" v-model="form.mobile"></el-input>
                    </el-form-item>
                    <el-form-item label="角色" prop="staff">
                        <span class="input-delete-wrap" v-for="(item,index) in form.roleList" :key="index">
                            <el-select v-model="item.id" placeholder="">
                                <el-option v-for="(it,index) in form.teamList" :label="it.name" :value="it.id" :key="index"></el-option>
                            </el-select>
                            <div class="btn-delete" @click="decreaseTeamMember(index)"></div>
                        </span>
                        <el-button size="small" type="text" @click="addTeamMember">继续添加</el-button>
                    </el-form-item>
                    <el-form-item label="初始密码" prop="password">
                        <el-input class="w150" v-model="form.password"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="handleCommit('form')" :loading="btnLoading">确定</el-button>
                        <el-button size="small" type="default" plain @click="pageNavigateToPermissionStaffList">取消</el-button>
                    </el-form-item>
                </el-form>
            </section>
</template>

<script>
import { staffUpdate, permissionRoleList, staffDetail } from '../../../common/api';

export default {
    data() {
        return {
            id: this.$route.query.id,
            form: {
                name: '', // 姓名
                mobile: '', // 手机号
                role: '', // 角色id
                roleList: [
                    {
                        id: ''
                    }
                ], // 角色列表
                teamList: [], // 可选团队成员列表
                password: '' // 初始密码
            },

            pageLoading: false,
            btnLoading: false,

            rules: {
                name: [
                    { required: true, message: '请输入员工姓名', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入初始密码', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        /**
         * [getRoleList description] 获取角色列表
         * @return {[type]}          [description]
         */
        getRoleList: function() {
            let param = {
                'pageNo': 1,
                'pageSize': 1000
            }
            
            permissionRoleList(param).then(res =>{

                let { code, data, msg } = res;

                if(code == 0) {
                    this.form.teamList = data.records || [];
                } else {
                    this.$message.error(msg);
                }
            }).catch(error => {
                this.$message.error('服务器异常');
            });
        },
        /**
         * [getList description] 获取详情
         * @return {[type]}          [description]
         */
        getList: function() {
            if(!this.id) {
                return false;
            }
            this.pageLoading = true;

            staffDetail({"id": this.id}).then(res =>{
                this.pageLoading = false;

                let { code, data, msg } = res;

                if(code == 0) {
                    this.form.name = data.name;
                    this.form.mobile = data.mobile;
                    for(let i in data.role) {
                        if(this.form.roleList[i] != undefined) {
                            this.form.roleList[i].id = data.role[i];
                        } else {
                            this.form.roleList.push({ id: data.role[i] });
                        }
                    }
                    this.form.password = data.password;
                } else {
                    this.$message.error(msg);
                }
            }).catch(error => {
                this.pageLoading = false;
                this.$message.error('服务器异常');
            });
        },
        /**
         * [addTeamMember description] 添加团队成员
         * @return {[type]}          [description]
         */
        addTeamMember: function() {
            this.form.roleList.push(
                {
                    id: ''
                }
            )
        },
        /**
         * [decreaseTeamMember description] 删除团队成员
         * @return {[type]}          [description]
         */
        decreaseTeamMember: function(index) {
            this.form.roleList.splice(index,1);
        },
        /**
         * [handleCommit description] 提交
         * @param  {[type]} formName [description]
         * @return {[type]}          [description]
         */
        handleCommit: function(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;

                    let str = '';
                    for(let i in this.form.roleList) {
                        if(this.form.roleList[i].id == '') {
                            this.$message.error('请保证所有角色选框都已选了角色');
                            return false;
                        }

                        if(i == 0) {
                            str += this.form.roleList[i].id;
                        } else {
                            str += ',' + this.form.roleList[i].id;
                        }
                    }


                    let param = {
                        'name': this.form.name,
                        'mobile': this.form.mobile,
                        'role': str,
                        'password': this.form.password
                    }

                    if(this.id) {
                        param.id = this.id;
                    }

                    staffUpdate(param).then(res =>{
                        this.btnLoading = false;

                        let { code, data, msg } = res;

                        if(code == 0) {
                            this.$message.success('保存成功');
                            this.$router.push('/permission/staff/list');
                        } else {
                            this.$message.error(msg);
                        }
                    }).catch(error => {
                        this.btnLoading = false;
                        this.$message.error('服务器异常');
                    });
                    
                } else {
                    return false;
                }
            });
        },
        /**
         * [pageNavigateToPermissionStaffList description] 取消-返回员工列表
         * @return {[type]}          [description]
         */
        pageNavigateToPermissionStaffList: function() {
            this.$router.push('/permission/staff/list');
        },
    },
    mounted() {
        this.getRoleList();
        this.getList();
    }
}
</script>

<style lang="scss" scoped>
    .input-delete-wrap{
        margin: 2px 10px 2px 0;
        & + .input-delete-wrap{
            margin-left: 0 !important;
        }

        &:last-of-type{
            margin-right: 0;
        }
    }
</style>

